import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import parse from 'html-react-parser';
import sanitize from 'sanitize-html';

import styles from '../styles.module.scss';
import { addTooltipToStyledContent } from '../addTooltipToStyledContent';
import { iframeSanitizeParams } from './StyledContentHtml';

const getTextAppearance = (parsedHTML) => {
	switch (typeof parsedHTML) {
		case 'string':
			return parsedHTML[0];
		case 'object':
			if (Array.isArray(parsedHTML)) {
				const elementWithChildren = parsedHTML.find(
					(item) => typeof item === 'string' || !!item?.children
				);

				if (elementWithChildren) {
					return getTextAppearance(elementWithChildren);
				}
				return parsedHTML;
			}
			return getTextAppearance(parsedHTML?.props?.children[0]);
		default:
			return parsedHTML ? parsedHTML[0] : {};
	}
};

const StyledContentText = ({ text, firstParagraph, className }) => {
	const parsedText = parse(sanitize(text, iframeSanitizeParams), {
		replace: addTooltipToStyledContent
	});

	const appendInitialParagraphStyles =
		firstParagraph && Number.isNaN(+getTextAppearance(parsedText));

	const pCx = cx(
		{
			[styles.initialParagraph]: appendInitialParagraphStyles
		},
		className
	);

	return (
		<div data-content="text" className={pCx}>
			{parsedText}
		</div>
	);
};

StyledContentText.propTypes = {
	className: PropTypes.string,
	text: PropTypes.string.isRequired,
	firstParagraph: PropTypes.bool
};

StyledContentText.defaultProps = {
	firstParagraph: false
};

export default StyledContentText;
